import { isPlugin } from "state/app";
import { getAccessToken } from "../auth/auth";
import { getAuthenticationFlow, getRelease } from "../config";
import { getPluginHost, pluginVersion } from "./pluginMessages";
import { getTraceId } from "./sentry";

const versionHeader = {
  "X-Client": "Bildebanken-UI-" + getRelease(),
};

export function getAppContext() {
  if (isPlugin) {
    const host = getPluginHost();
    return "plugin" + (host ? " " + host : "");
  }

  return "standalone " + window.location.hostname;
}

export async function apiFetch(...args: Parameters<typeof fetch>) {
  if (!args[1]) {
    throw RangeError("apiFetch called without second argument");
  }

  const flow = getAuthenticationFlow();
  const accessToken = await getAccessToken(flow);

  const buildInit = (token: string) => {
    const init = {
      ...args[1],
      headers: {
        ...args[1]!.headers,
        ...versionHeader,
        authorization: `Bearer ${token}`,
        "X-Context": getAppContext(),
        "X-Bildebanken-Plugin-Version": pluginVersion,
      },
    };

    const sentryTraceId = getTraceId();
    if (sentryTraceId) {
      init.headers["Sentry-Trace"] = sentryTraceId;
    }

    return init;
  };

  const response = await fetch(args[0], buildInit(accessToken));

  if (response.status === 401) {
    try {
      const freshToken = await getAccessToken(flow, { forceRefresh: true, preferPopup: true });
      return fetch(args[0], buildInit(freshToken));
    } catch {
      return response;
    }
  }

  return response;
}
